import { useRef, useState, useEffect } from 'react'
import arrowdown from "../../assets/arrow-down.svg";
import search from "../../assets/search.svg";
import { useI18n } from '../../../i18n/useI18n';
import assigmentStyles from '../../../assignments/styles/assignment.module.scss';
import { ISection } from '@/api/projects/types';
import { UseFormSetValue, UseFormTrigger } from "react-hook-form";
import { IFormData } from '@/api/tasks/types';

interface SelectComponentProps {
  list?: ISection[];
  setProjectList?: (list: ISection[]) => void;
  originalList?: ISection[];
  placeHolder?: string;
  setValue: UseFormSetValue<IFormData>;
  trigger: UseFormTrigger<IFormData>;
  name: "projectId" | "sectionId" | "title" | "description" | "state" | "createdAt" | "parentTaskId";
  errorMessage?: string | null;
  classNameError?: string;
  onSectionChange?: (sectionId: string) => Promise<void>;
  selectedItem?: ISection | null;
}

const SectionsSelect = ({
  list = [],
  setProjectList = () => { },
  originalList = [],
  placeHolder = "global_components.placeholder_search_project",
  setValue,
  trigger,
  name,
  errorMessage,
  classNameError,
  onSectionChange,
  selectedItem: initialSelectedItem
}: SelectComponentProps) => {
  const [selectedItem, setSelectedItem] = useState<ISection | null>(initialSelectedItem || null);
  const { t } = useI18n();
  const [showListSelected, setShowListSelected] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (initialSelectedItem) {
      setSelectedItem(initialSelectedItem);
    }
  }, [initialSelectedItem]);

  const handleClick = () => {
    setShowListSelected(true);
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  }
  function filterProjects(projects: ISection[], term: string) {
    return projects.filter((project) => {
      return project.name.toLowerCase().includes(term.toLowerCase());
    });
  }

  const filterProject = (a: string) => {
    let projects = originalList;
    if (a === '') {
      setProjectList(originalList);
    } else {
      projects = filterProjects(projects, a);
      setProjectList(projects);
    }
  };

  const handleSelect = async (itemSelected: ISection) => {
    setSelectedItem(itemSelected);
    setValue(name, String(itemSelected.id), { shouldValidate: true });
    trigger(name);
    if (onSectionChange) {
      await onSectionChange(String(itemSelected.id));
    }
    setShowListSelected(false);
  }

  return (
    <div className={assigmentStyles["select-component"]}>
      <div className={assigmentStyles["select-component__input"]}>
        <input
          type="text"
          placeholder={t(placeHolder)}
          onChange={(e) => filterProject(e.target.value)}
          onFocus={handleClick}
          ref={inputRef}
          value={selectedItem?.name || ''}
          readOnly
        />
        <div className={assigmentStyles["select-component__input-icons"]}>
          <img src={search} alt="search" />
          <img src={arrowdown} alt="arrow" />
        </div>
      </div>
      {showListSelected && (
        <div className={assigmentStyles["select-component__list"]}>
          {list.map((item) => (
            <div
              key={item.id}
              className={`${assigmentStyles["select-component__list-item"]} ${selectedItem?.id === item.id ? assigmentStyles["select-component__list-item--selected"] : ''}`}
              onClick={() => handleSelect(item)}
            >
              {item.name}
            </div>
          ))}
        </div>
      )}
      {errorMessage && (
        <span className={classNameError}>{errorMessage}</span>
      )}
    </div>
  );
}

export default SectionsSelect;